/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation NotifyClearMutation($customerId: ID!) {
    NotifyClear(customerId: $customerId) {
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
